var chunkMapping = {
	"vendors-node_modules_umijs_bundler-webpack_client_client_client_js": [
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/@umijs/utils/compiled/strip-ansi/index.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/react-error-overlay/lib/index.js"
	],
	"vendors-node_modules_umijs_bundler-webpack_compiled_mini-css-extract-plugin_hmr_hotModuleRepl-27cc2e": [
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/antd/dist/reset.css",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/@umijs/renderer-react",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/antd",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/react/jsx-dev-runtime",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/umi/client/client/plugin.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/es.error.cause.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/es.aggregate-error.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/es.aggregate-error.cause.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/es.array.at.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/es.array.find-last.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/es.array.find-last-index.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/es.array.push.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/es.array.reduce.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/es.array.reduce-right.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/es.array.to-reversed.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/es.array.to-sorted.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/es.array.to-spliced.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/es.array.with.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/es.map.group-by.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/es.object.group-by.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/es.object.has-own.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/es.promise.any.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/es.promise.with-resolvers.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/es.reflect.to-string-tag.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/es.regexp.flags.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/es.string.at-alternative.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/es.string.is-well-formed.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/es.string.replace-all.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/es.string.to-well-formed.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/es.typed-array.at.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/es.typed-array.find-last.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/es.typed-array.find-last-index.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/es.typed-array.set.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/es.typed-array.to-reversed.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/es.typed-array.to-sorted.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/es.typed-array.with.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.suppressed-error.constructor.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.array.from-async.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.array.filter-out.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.array.filter-reject.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.array.group.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.array.group-by.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.array.group-by-to-map.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.array.group-to-map.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.array.is-template-object.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.array.last-index.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.array.last-item.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.array.unique-by.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.array-buffer.detached.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.array-buffer.transfer.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.array-buffer.transfer-to-fixed-length.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.async-disposable-stack.constructor.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.async-iterator.constructor.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.async-iterator.as-indexed-pairs.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.async-iterator.async-dispose.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.async-iterator.drop.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.async-iterator.every.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.async-iterator.filter.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.async-iterator.find.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.async-iterator.flat-map.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.async-iterator.for-each.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.async-iterator.from.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.async-iterator.indexed.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.async-iterator.map.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.async-iterator.reduce.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.async-iterator.some.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.async-iterator.take.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.async-iterator.to-array.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.bigint.range.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.composite-key.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.composite-symbol.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.data-view.get-float16.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.data-view.get-uint8-clamped.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.data-view.set-float16.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.data-view.set-uint8-clamped.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.disposable-stack.constructor.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.function.demethodize.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.function.is-callable.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.function.is-constructor.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.function.metadata.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.function.un-this.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.iterator.constructor.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.iterator.as-indexed-pairs.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.iterator.dispose.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.iterator.drop.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.iterator.every.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.iterator.filter.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.iterator.find.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.iterator.flat-map.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.iterator.for-each.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.iterator.from.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.iterator.indexed.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.iterator.map.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.iterator.range.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.iterator.reduce.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.iterator.some.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.iterator.take.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.iterator.to-array.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.iterator.to-async.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.json.is-raw-json.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.json.parse.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.json.raw-json.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.map.delete-all.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.map.emplace.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.map.every.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.map.filter.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.map.find.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.map.find-key.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.map.from.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.map.includes.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.map.key-by.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.map.key-of.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.map.map-keys.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.map.map-values.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.map.merge.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.map.of.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.map.reduce.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.map.some.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.map.update.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.map.update-or-insert.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.map.upsert.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.math.clamp.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.math.deg-per-rad.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.math.degrees.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.math.fscale.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.math.f16round.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.math.iaddh.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.math.imulh.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.math.isubh.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.math.rad-per-deg.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.math.radians.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.math.scale.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.math.seeded-prng.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.math.signbit.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.math.umulh.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.number.from-string.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.number.range.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.object.iterate-entries.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.object.iterate-keys.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.object.iterate-values.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.observable.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.promise.try.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.reflect.define-metadata.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.reflect.delete-metadata.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.reflect.get-metadata.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.reflect.get-metadata-keys.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.reflect.get-own-metadata.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.reflect.get-own-metadata-keys.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.reflect.has-metadata.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.reflect.has-own-metadata.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.reflect.metadata.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.regexp.escape.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.set.add-all.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.set.delete-all.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.set.difference.v2.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.set.difference.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.set.every.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.set.filter.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.set.find.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.set.from.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.set.intersection.v2.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.set.intersection.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.set.is-disjoint-from.v2.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.set.is-disjoint-from.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.set.is-subset-of.v2.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.set.is-subset-of.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.set.is-superset-of.v2.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.set.is-superset-of.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.set.join.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.set.map.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.set.of.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.set.reduce.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.set.some.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.set.symmetric-difference.v2.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.set.symmetric-difference.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.set.union.v2.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.set.union.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.string.at.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.string.cooked.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.string.code-points.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.string.dedent.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.symbol.async-dispose.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.symbol.dispose.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.symbol.is-registered-symbol.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.symbol.is-registered.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.symbol.is-well-known-symbol.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.symbol.is-well-known.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.symbol.matcher.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.symbol.metadata.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.symbol.metadata-key.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.symbol.observable.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.symbol.pattern-match.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.symbol.replace-all.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.typed-array.from-async.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.typed-array.filter-out.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.typed-array.filter-reject.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.typed-array.group-by.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.typed-array.to-spliced.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.typed-array.unique-by.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.uint8-array.from-base64.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.uint8-array.from-hex.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.uint8-array.to-base64.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.uint8-array.to-hex.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.weak-map.delete-all.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.weak-map.from.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.weak-map.of.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.weak-map.emplace.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.weak-map.upsert.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.weak-set.add-all.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.weak-set.delete-all.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.weak-set.from.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.weak-set.of.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/web.dom-exception.stack.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/web.immediate.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/web.self.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/web.structured-clone.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/web.url.can-parse.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/web.url-search-params.delete.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/web.url-search-params.has.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/web.url-search-params.size.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/regenerator-runtime/runtime.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/react",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/fast-deep-equal/index.js",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/lodash/merge",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/react-intl",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/event-emitter",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/warning",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/DashboardOutlined",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/BankOutlined",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/SafetyCertificateOutlined",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/ApiOutlined",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/ShoppingCartOutlined",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/SettingOutlined",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/TeamOutlined",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/FileSearchOutlined",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/moment",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/moment/locale/zh-cn",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/antd/es/locale/zh_CN"
	],
	"src_umi_umi_ts": [
		"webpack/container/remote/mf/@ant-design/icons",
		"webpack/container/remote/mf/@ant-design/pro-components",
		"webpack/container/remote/mf/dayjs"
	],
	"vendors-webpack_container_remote_mf_home_ubuntu_yanglao_platform-demo_node_modules_ant-design-b5bef0": [
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/@ant-design/pro-components",
		"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/@umijs/plugins/node_modules/@ant-design/icons"
	]
};
var idToExternalAndNameMapping = {
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/@umijs/utils/compiled/strip-ansi/index.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/@umijs/utils/compiled/strip-ansi/index.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/react-error-overlay/lib/index.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/react-error-overlay/lib/index.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/antd/dist/reset.css": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/antd/dist/reset.css",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/@umijs/renderer-react": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/@umijs/renderer-react",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/antd": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/antd",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/react/jsx-dev-runtime": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/react/jsx-dev-runtime",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/umi/client/client/plugin.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/umi/client/client/plugin.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/es.error.cause.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/es.error.cause.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/es.aggregate-error.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/es.aggregate-error.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/es.aggregate-error.cause.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/es.aggregate-error.cause.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/es.array.at.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/es.array.at.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/es.array.find-last.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/es.array.find-last.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/es.array.find-last-index.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/es.array.find-last-index.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/es.array.push.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/es.array.push.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/es.array.reduce.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/es.array.reduce.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/es.array.reduce-right.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/es.array.reduce-right.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/es.array.to-reversed.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/es.array.to-reversed.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/es.array.to-sorted.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/es.array.to-sorted.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/es.array.to-spliced.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/es.array.to-spliced.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/es.array.with.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/es.array.with.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/es.map.group-by.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/es.map.group-by.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/es.object.group-by.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/es.object.group-by.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/es.object.has-own.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/es.object.has-own.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/es.promise.any.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/es.promise.any.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/es.promise.with-resolvers.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/es.promise.with-resolvers.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/es.reflect.to-string-tag.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/es.reflect.to-string-tag.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/es.regexp.flags.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/es.regexp.flags.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/es.string.at-alternative.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/es.string.at-alternative.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/es.string.is-well-formed.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/es.string.is-well-formed.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/es.string.replace-all.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/es.string.replace-all.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/es.string.to-well-formed.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/es.string.to-well-formed.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/es.typed-array.at.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/es.typed-array.at.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/es.typed-array.find-last.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/es.typed-array.find-last.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/es.typed-array.find-last-index.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/es.typed-array.find-last-index.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/es.typed-array.set.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/es.typed-array.set.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/es.typed-array.to-reversed.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/es.typed-array.to-reversed.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/es.typed-array.to-sorted.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/es.typed-array.to-sorted.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/es.typed-array.with.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/es.typed-array.with.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.suppressed-error.constructor.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.suppressed-error.constructor.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.array.from-async.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.array.from-async.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.array.filter-out.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.array.filter-out.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.array.filter-reject.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.array.filter-reject.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.array.group.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.array.group.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.array.group-by.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.array.group-by.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.array.group-by-to-map.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.array.group-by-to-map.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.array.group-to-map.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.array.group-to-map.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.array.is-template-object.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.array.is-template-object.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.array.last-index.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.array.last-index.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.array.last-item.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.array.last-item.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.array.unique-by.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.array.unique-by.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.array-buffer.detached.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.array-buffer.detached.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.array-buffer.transfer.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.array-buffer.transfer.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.array-buffer.transfer-to-fixed-length.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.array-buffer.transfer-to-fixed-length.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.async-disposable-stack.constructor.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.async-disposable-stack.constructor.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.async-iterator.constructor.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.async-iterator.constructor.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.async-iterator.as-indexed-pairs.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.async-iterator.as-indexed-pairs.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.async-iterator.async-dispose.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.async-iterator.async-dispose.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.async-iterator.drop.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.async-iterator.drop.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.async-iterator.every.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.async-iterator.every.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.async-iterator.filter.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.async-iterator.filter.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.async-iterator.find.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.async-iterator.find.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.async-iterator.flat-map.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.async-iterator.flat-map.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.async-iterator.for-each.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.async-iterator.for-each.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.async-iterator.from.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.async-iterator.from.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.async-iterator.indexed.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.async-iterator.indexed.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.async-iterator.map.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.async-iterator.map.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.async-iterator.reduce.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.async-iterator.reduce.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.async-iterator.some.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.async-iterator.some.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.async-iterator.take.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.async-iterator.take.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.async-iterator.to-array.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.async-iterator.to-array.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.bigint.range.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.bigint.range.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.composite-key.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.composite-key.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.composite-symbol.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.composite-symbol.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.data-view.get-float16.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.data-view.get-float16.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.data-view.get-uint8-clamped.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.data-view.get-uint8-clamped.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.data-view.set-float16.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.data-view.set-float16.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.data-view.set-uint8-clamped.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.data-view.set-uint8-clamped.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.disposable-stack.constructor.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.disposable-stack.constructor.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.function.demethodize.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.function.demethodize.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.function.is-callable.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.function.is-callable.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.function.is-constructor.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.function.is-constructor.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.function.metadata.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.function.metadata.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.function.un-this.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.function.un-this.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.iterator.constructor.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.iterator.constructor.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.iterator.as-indexed-pairs.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.iterator.as-indexed-pairs.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.iterator.dispose.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.iterator.dispose.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.iterator.drop.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.iterator.drop.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.iterator.every.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.iterator.every.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.iterator.filter.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.iterator.filter.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.iterator.find.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.iterator.find.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.iterator.flat-map.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.iterator.flat-map.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.iterator.for-each.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.iterator.for-each.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.iterator.from.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.iterator.from.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.iterator.indexed.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.iterator.indexed.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.iterator.map.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.iterator.map.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.iterator.range.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.iterator.range.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.iterator.reduce.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.iterator.reduce.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.iterator.some.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.iterator.some.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.iterator.take.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.iterator.take.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.iterator.to-array.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.iterator.to-array.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.iterator.to-async.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.iterator.to-async.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.json.is-raw-json.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.json.is-raw-json.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.json.parse.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.json.parse.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.json.raw-json.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.json.raw-json.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.map.delete-all.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.map.delete-all.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.map.emplace.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.map.emplace.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.map.every.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.map.every.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.map.filter.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.map.filter.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.map.find.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.map.find.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.map.find-key.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.map.find-key.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.map.from.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.map.from.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.map.includes.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.map.includes.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.map.key-by.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.map.key-by.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.map.key-of.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.map.key-of.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.map.map-keys.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.map.map-keys.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.map.map-values.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.map.map-values.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.map.merge.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.map.merge.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.map.of.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.map.of.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.map.reduce.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.map.reduce.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.map.some.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.map.some.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.map.update.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.map.update.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.map.update-or-insert.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.map.update-or-insert.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.map.upsert.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.map.upsert.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.math.clamp.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.math.clamp.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.math.deg-per-rad.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.math.deg-per-rad.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.math.degrees.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.math.degrees.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.math.fscale.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.math.fscale.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.math.f16round.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.math.f16round.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.math.iaddh.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.math.iaddh.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.math.imulh.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.math.imulh.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.math.isubh.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.math.isubh.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.math.rad-per-deg.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.math.rad-per-deg.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.math.radians.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.math.radians.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.math.scale.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.math.scale.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.math.seeded-prng.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.math.seeded-prng.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.math.signbit.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.math.signbit.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.math.umulh.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.math.umulh.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.number.from-string.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.number.from-string.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.number.range.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.number.range.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.object.iterate-entries.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.object.iterate-entries.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.object.iterate-keys.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.object.iterate-keys.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.object.iterate-values.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.object.iterate-values.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.observable.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.observable.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.promise.try.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.promise.try.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.reflect.define-metadata.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.reflect.define-metadata.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.reflect.delete-metadata.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.reflect.delete-metadata.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.reflect.get-metadata.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.reflect.get-metadata.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.reflect.get-metadata-keys.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.reflect.get-metadata-keys.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.reflect.get-own-metadata.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.reflect.get-own-metadata.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.reflect.get-own-metadata-keys.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.reflect.get-own-metadata-keys.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.reflect.has-metadata.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.reflect.has-metadata.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.reflect.has-own-metadata.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.reflect.has-own-metadata.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.reflect.metadata.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.reflect.metadata.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.regexp.escape.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.regexp.escape.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.set.add-all.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.set.add-all.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.set.delete-all.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.set.delete-all.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.set.difference.v2.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.set.difference.v2.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.set.difference.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.set.difference.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.set.every.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.set.every.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.set.filter.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.set.filter.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.set.find.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.set.find.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.set.from.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.set.from.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.set.intersection.v2.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.set.intersection.v2.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.set.intersection.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.set.intersection.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.set.is-disjoint-from.v2.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.set.is-disjoint-from.v2.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.set.is-disjoint-from.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.set.is-disjoint-from.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.set.is-subset-of.v2.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.set.is-subset-of.v2.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.set.is-subset-of.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.set.is-subset-of.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.set.is-superset-of.v2.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.set.is-superset-of.v2.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.set.is-superset-of.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.set.is-superset-of.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.set.join.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.set.join.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.set.map.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.set.map.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.set.of.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.set.of.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.set.reduce.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.set.reduce.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.set.some.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.set.some.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.set.symmetric-difference.v2.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.set.symmetric-difference.v2.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.set.symmetric-difference.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.set.symmetric-difference.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.set.union.v2.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.set.union.v2.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.set.union.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.set.union.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.string.at.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.string.at.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.string.cooked.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.string.cooked.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.string.code-points.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.string.code-points.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.string.dedent.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.string.dedent.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.symbol.async-dispose.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.symbol.async-dispose.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.symbol.dispose.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.symbol.dispose.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.symbol.is-registered-symbol.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.symbol.is-registered-symbol.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.symbol.is-registered.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.symbol.is-registered.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.symbol.is-well-known-symbol.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.symbol.is-well-known-symbol.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.symbol.is-well-known.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.symbol.is-well-known.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.symbol.matcher.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.symbol.matcher.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.symbol.metadata.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.symbol.metadata.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.symbol.metadata-key.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.symbol.metadata-key.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.symbol.observable.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.symbol.observable.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.symbol.pattern-match.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.symbol.pattern-match.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.symbol.replace-all.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.symbol.replace-all.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.typed-array.from-async.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.typed-array.from-async.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.typed-array.filter-out.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.typed-array.filter-out.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.typed-array.filter-reject.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.typed-array.filter-reject.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.typed-array.group-by.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.typed-array.group-by.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.typed-array.to-spliced.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.typed-array.to-spliced.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.typed-array.unique-by.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.typed-array.unique-by.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.uint8-array.from-base64.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.uint8-array.from-base64.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.uint8-array.from-hex.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.uint8-array.from-hex.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.uint8-array.to-base64.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.uint8-array.to-base64.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.uint8-array.to-hex.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.uint8-array.to-hex.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.weak-map.delete-all.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.weak-map.delete-all.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.weak-map.from.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.weak-map.from.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.weak-map.of.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.weak-map.of.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.weak-map.emplace.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.weak-map.emplace.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.weak-map.upsert.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.weak-map.upsert.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.weak-set.add-all.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.weak-set.add-all.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.weak-set.delete-all.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.weak-set.delete-all.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.weak-set.from.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.weak-set.from.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.weak-set.of.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/esnext.weak-set.of.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/web.dom-exception.stack.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/web.dom-exception.stack.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/web.immediate.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/web.immediate.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/web.self.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/web.self.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/web.structured-clone.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/web.structured-clone.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/web.url.can-parse.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/web.url.can-parse.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/web.url-search-params.delete.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/web.url-search-params.delete.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/web.url-search-params.has.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/web.url-search-params.has.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/web.url-search-params.size.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/core-js/modules/web.url-search-params.size.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/regenerator-runtime/runtime.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/regenerator-runtime/runtime.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/react": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/react",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/fast-deep-equal/index.js": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/fast-deep-equal/index.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/lodash/merge": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/lodash/merge",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/react-intl": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/react-intl",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/event-emitter": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/event-emitter",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/warning": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/warning",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/DashboardOutlined": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/DashboardOutlined",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/BankOutlined": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/BankOutlined",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/SafetyCertificateOutlined": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/SafetyCertificateOutlined",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/ApiOutlined": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/ApiOutlined",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/ShoppingCartOutlined": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/ShoppingCartOutlined",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/SettingOutlined": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/SettingOutlined",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/TeamOutlined": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/TeamOutlined",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/FileSearchOutlined": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/FileSearchOutlined",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/moment": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/moment",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/moment/locale/zh-cn": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/moment/locale/zh-cn",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/antd/es/locale/zh_CN": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/antd/es/locale/zh_CN",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf/@ant-design/icons": [
		"default",
		"./@ant-design/icons",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf/@ant-design/pro-components": [
		"default",
		"./@ant-design/pro-components",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf/dayjs": [
		"default",
		"./dayjs",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/@ant-design/pro-components": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/@ant-design/pro-components",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//home/ubuntu/yanglao/platform-demo/node_modules/@umijs/plugins/node_modules/@ant-design/icons": [
		"default",
		".//home/ubuntu/yanglao/platform-demo/node_modules/@umijs/plugins/node_modules/@ant-design/icons",
		"webpack/container/reference/mf"
	]
};
__webpack_require__.f.remotes = function(chunkId, promises) {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach(function(id) {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = function(error) {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = function() {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = function(fn, arg1, arg2, d, next, first) {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then(function(result) { return next(result, d); }, onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = function(external, _, first) { return external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError(); };
			var onInitialized = function(_, external, first) { return handleFunction(external.get, data[1], getScope, 0, onFactory, first); };
			var onFactory = function(factory) {
				data.p = 1;
				__webpack_require__.m[id] = function(module) {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}